import { hc } from 'hono/client';
// Importamos o tipo do backend para ter Type Safety total
// Em um ambiente real, poderíamos usar um workspace do npm ou um path alias
export const API_URL = (import.meta as any).env?.VITE_API_URL || 
  (window.location.hostname === 'localhost' ? 'http://localhost:8787' : 'https://crm-bff.inteligencia-e-negocios.workers.dev');

export const api = hc<any>(API_URL);

export const crm = (api as any).v1?.crm;
